// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3633":"975ca71e","7016":"8691eb9e","8162":"8691eb9e"}[chunkId] + ".chunk.css";
};